import React, { useEffect, useState } from "react";
import { Form, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import Loader from "../../components/Loader";
import EmailSender from "../../components/EmailSender";
import io from "socket.io-client";

const socket = io("http://192.168.18.104:5000"); // Backend Socket.io server
const sessionId = Math.random().toString(36).substr(2, 9);
const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function SendEmails(){
    const API_URL = BASE_URL+"/authenticateemail";
    const navigate = useNavigate();

    //getting countries
    const GET_EMAIL_URL = BASE_URL+"/getemails";

    const [emails, setEmail] = useState([]);
    const [response, setResponse] = useState(null);

    //get emails
    useEffect(() => {
        axios.get(GET_EMAIL_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                setEmail(res.data);
                setLoading(false);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error)
            }
        )
    }, [])

    //getting countries
    const GET_COUNTRY_URL = BASE_URL+"/getcountries";

    const [countries, setCountry] = useState([]);
    useEffect(() => {
        axios.get(GET_COUNTRY_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                setCountry(res.data);
                setLoading(false);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error)
            }
        )
    }, [])

    //getting email template
    const TEMPLATE_URL = BASE_URL+"/gettemplates";

    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        axios.get(TEMPLATE_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                setTemplates(res.data);
                setLoading(false);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error)
            }
        )
    }, [])

    const [getcountry, setGetCountry] = useState(null);
    const [getPassword, setPassword] = useState(null);
    const [getEmail, setGetEmail] = useState(null);
    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const email = formData.get("email");
        const password = formData.get("password");
        const country = formData.get("country");
        setGetCountry(formData.get("country"));
        setPassword(formData.get("password"));
        setGetEmail(formData.get("email"));
        
        if(!email || !password || !country){
            toast.error("All fields are required!");
        }
        else{
            const data = {
                Email: email,
                Password: password,
            }
            axios.post(API_URL, data, {
                headers: {
                    "Authorization": apiKey,
                    "Content-Type": "application/json"
                }
            })
            .then(
                res => {
                    // navigate("/emails/email-templates");
                    toast.success("Authenticated Successfully");

                    const filteredTemplates = templates.filter(template => template.Country === country);
                    if(filteredTemplates.length == 0){
                        toast.error(`There are no templates for ${country}`)
                    }
                    else{
                        setHostName(res.data.hostName);
                        setPort(res.data.port)
                        setResponse(res.data);
                    }
                }
            )
            .catch(
                error => {
                    if(error.response.data.message == "Invalid Email or Password"){
                        toast.error("Invalid Email or Password!");
                    }
                    console.error(error);
                }
            )
        }
    }

    //emails sending code...
    const [hostName, setHostName] = useState(null);
    const [port, setPort] = useState(null);
    const [file, setFile] = useState(null);
    const [subject, setSubject] = useState("");
    const [progress, setProgress] = useState(0);
    const [totalEmails, setTotalEmails] = useState(0);
    const [sentEmails, setSentEmails] = useState([]);
    const [failedEmails, setFailedEmails] = useState([]);
    const [businessCard, setBusinessCard] = useState(null); // Business card image state


    useEffect(() => {
        if (!sessionId) return; // Ensure sessionId is available
    
        socket.emit("register", sessionId); // Register this session with backend
    
        // Real-time progress updates for this session
        socket.on("progress", ({ current, total }) => {
            setProgress(current);
            setTotalEmails(total);
        });
    
        // Receive final sent & failed emails for this session
        socket.on("emailResult", ({ success, failed }) => {
            setSentEmails(success);
            setFailedEmails(failed);
            setLoading(false);
        });
    
        return () => {
            socket.off("progress");
            socket.off("emailResult");
        };
    }, [sessionId]); // Depend on sessionId to re-run if it changes        
    
    const startEmailSending = async () => {
        setProgress(0);
        setTotalEmails(0);
        setSentEmails([]);
        setFailedEmails([]);
        
        const data = {
            country: getcountry,
            csvFile: file,
            businessCard: businessCard,
            hostName: hostName,
            port: port,
            email: getEmail,
            password: getPassword,
            subject: subject,
            sessionId: sessionId
        };
    
        try {
            await axios.post("http://192.168.18.104:5000/runemails", data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("Failed to upload file");
            setLoading(false);
        }
    };

    const handleUpload = async () => {
        if (!file || !businessCard || isStopped) {
            alert("Missing file, business card, or session stopped.");
            return;
        }
    
        if (!scheduleDateTime) {
            startEmailSending();
            return;
        }
    
        const now = new Date();
        const scheduledTime = new Date(scheduleDateTime);
    
        if (isNaN(scheduledTime.getTime())) {
            alert("Invalid scheduled date.");
            return;
        }
    
        if (scheduledTime > now) {
            const delay = scheduledTime - now;
            toast.info(`Scheduled to start at ${scheduledTime.toLocaleString()}`);
            setTimeout(() => {
                startEmailSending();
            }, delay);
        } else {
            startEmailSending();
        }
    };   

    const [isStopped, setIsStopped] = useState(false);

    const handleStopEmails = () => {
        setIsStopped(true);
        socket.emit("stopEmails", sessionId); // Notify backend
        toast.info("Email sending stopped for this session.");
    };
    
    const [scheduleDateTime, setScheduleDateTime] = useState("");

    const [loading, setLoading] = useState(true);
    if (loading) return <Loader />;
    return(
        <div className="container">
            <ToastContainer />
            <h2>Email Sender</h2>
            <br />
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <select className="form-control" name="email" required disabled={response}>
                            <option disabled selected>Select Email</option>
                            {emails
                            .map(email => (
                                <option value={email.Email}>{email.Email}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-sm-6">
                        <input type="password" placeholder="Enter Password Here" className="form-control" id="inputPassword5" name="password" required disabled={response}/>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-6">
                        <select className="form-control" name="country" required disabled={response}>
                            <option disabled selected>Select Template</option>
                            {countries
                            .filter(country => country.Status === "Deactive")
                            .map(country => (
                                <option value={country.Country}>{country.Country}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-6">
                        <button className="btn btn-primary" disabled={response}>Authenticate</button>
                    </div>
                </div>
            </form>
            <br />
            {response && (
                <div className="row">
                    <h3>Email templates for {getcountry}</h3>
                    {response && 
                    templates
                    .filter(template => template.Country === getcountry)
                    .map(template => (
                        <div class="card" style={{width: "20rem", margin: "10px"}}>
                            <div class="card-body" style={{ whiteSpace: "pre-line", border: "1px solid #ddd", padding: "10px", marginBottom: "10px", color: "black" }}>
                                <p className="text-dark" dangerouslySetInnerHTML={{ __html: template.Template }}></p>
                            </div>
                        </div>
                    ))}

                    <div>
                                <h2>Upload Data Here</h2>
                                <p><i>Note: CSV must have maximum 2000 rows and column sequence like this <b>"email | clientName | businessName | phoneNumber"</b> with exact spellings.</i></p>

                                <div className="row">
                                    <div className="col-sm-6">
                                    <label>CSV File:</label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => setFile(e.target.files[0])}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label>Business Card (Image URL):</label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => setBusinessCard(e.target.files[0])}
                                        />
                                    </div>
                                    <div className="col-sm-6 mt-3">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Enter Subject For The Emails"
                                            value={subject}
                                            onChange={(e) => setSubject(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="col-sm-6 mt-3">
                                    <label>Schedule Email Run (optional):</label>
                                    <input
                                        className="form-control"
                                        type="datetime-local"
                                        value={scheduleDateTime}
                                        onChange={(e) => setScheduleDateTime(e.target.value)}
                                    />
                                </div>
                                <br />
                                <button className="btn btn-primary" onClick={handleUpload} disabled={totalEmails > 0}>
                                    {loading ? "Processing..." : "Run All Emails"}
                                </button>
                                <button
                                    className="btn btn-danger ms-2"
                                    onClick={handleStopEmails}
                                    disabled={isStopped || totalEmails === 0}
                                >
                                    Stop Emails
                                </button>

                                {/* Progress Bar */}
                                {totalEmails > 0 && (
                                    <h3>Progress: {progress}/{totalEmails} ({Math.round((progress / totalEmails) * 100)}%)</h3>
                                )}

                                {/* Successfully Sent Emails */}
                                {sentEmails.length > 0 && (
                                    <div>
                                        <h4>✅ Successfully Sent Emails ({sentEmails.length})</h4>
                                        <ul className="emails-list">
                                            {sentEmails.map((email, index) => (
                                                <li key={email || index}>{email}</li> // email ko key banana better hai
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Failed Emails */}
                                {failedEmails.length > 0 && (
                                    <div className="emails-list">
                                        <h4>❌ Failed Emails ({failedEmails.length})</h4>
                                        <ul>
                                            {failedEmails.map((email, index) => (
                                                <li key={email || index}>{email}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                </div>
            )}
        </div>
    );
}